import React, { ReactNode } from 'react';
import ShareButtonContainer from './ShareButtonContainer';

interface ShareLinkProps {
    href: string;
    icon: ReactNode;
}

function ShareLink({ href, icon }: ShareLinkProps): React.JSX.Element {
    return (
        <ShareButtonContainer>
            <a href={href} className="flex" target="_blank" rel="noreferrer">
                {icon}
            </a>
        </ShareButtonContainer>
    );
}

export default ShareLink;
